export default {
    isOpen: false,
    messages: [],
    isLoading: false
  }